import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import _ from "lodash";
import { Grid, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import MoveDownIcon from "@mui/icons-material/MoveDown";

import InfoIcon from "@mui/icons-material/Info";
import PsychologyIcon from "@mui/icons-material/Psychology";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import PauseIcon from "@mui/icons-material/Pause";
import AudioButton from "../../Media/AudioButton";
import { unicodeToString } from "../../../Js/Common";
import AssetInfo from "../../Modal/AssetInfo";

const InstructionCard = (props) => {
  const classes = useStyles();

  //State
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [infoModl, setInfoModl] = useState(false);

  const open = Boolean(anchorEl);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // useEffect(()=>{
  //     if(isJumpTo && props.isJumpTo) {
  //       setIsJumpTo(props.isJumpTo);
  //     }
  // },[isJumpTo])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ height: "8.4vh" }}
    >
      <Grid
        item
        xs={12}
        sx={{
          backgroundColor: "#3eda00ff",
          mx: 5,
          borderRadius: 10,
          px: 2,
          py: 1,
          minHeight: "4.4vh",
          maxHeight: "8.4vh",
          overflow: "auto",
          "@media (min-width: 1636px)": {
            minHeight: "1.8vh",
            maxHeight: "6.4vh",
          },
        }}
         
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{
            "@media (min-width: 1636px)": {
              mt: 1,
            },
          }}
        >
          <Grid
            item
            xs={userInfo.rolesInfo.title.toLowerCase() == "learner" ? 12 : 11}
          >
            {userInfo &&
              userInfo.rolesInfo.title.toLowerCase() != "learner" &&
              props.info &&
              props.info.skills &&
              props.info.skills.length > 0 && (
                <IconButton
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#FFFFFF",
                    mr: props.globalObject?.media?.audio ? 0 : 1,
                    padding: 0,
                   
                  }}
                  onClick={() => {
                    setInfoModl(true);
                  }}
                >
                  <PsychologyIcon
                    sx={{
                      borderRadius: "50%",
                      fontSize: "2rem",
                      padding: 0.2,
                      "@media (min-width: 1636px)": {
                        fontSize: "2.2rem",
                      },
                    }}
                  />
                </IconButton>
              )}
            {props.globalObject?.media?.audio && (
              <AudioButton
                expertAudio={props.globalObject?.media?.audio}
                playStatus={(status) => setIsPlaying(status)}
              >
                <IconButton
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#FFFFFF",
                    mx: 1,
                    padding: 0,
                   
                  }}
                >
                  {isPlaying && (
                    <PauseIcon
                      sx={{
                        borderRadius: "50%",
                        padding: 1,
                        color: "#5f5600ff",
                        "@media (min-width: 1636px)": {
                          fontSize: "2.2rem",
                        },
                      }}
                    />
                  )}
                  {!isPlaying && (
                    <VolumeUpIcon
                      sx={{
                        borderRadius: "50%",
                        padding: 1,
                        "@media (min-width: 1636px)": {
                          fontSize: "2.2rem",
                        },
                      }}
                    />
                  )}
                </IconButton>
              </AudioButton>
            )}
            {!props.avpairText && (
              <Typography
                color="#5f5600ff"
                sx={{
                  fontWeight: "600",
                  fontSize: "1rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.5rem",
                  },
                }}
                component={"span"}
              >
                {props.text ? props.text : ""}
              </Typography>
            )}
            {props.avpairText &&
              props.avpairText.map((textVal, ind) => {
                return (
                  <Typography
                    color="#5f5600ff"
                    sx={{
                      fontWeight: "600",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.5rem",
                      },
                    }}
                    component={"span"}
                  >
                    {textVal.text ? unicodeToString(textVal.text) : ""}
                  </Typography>
                );
              })}
          </Grid>
          <Grid item xs={1} sx={{ textAlign: "right" }}>
            {userInfo.rolesInfo.title.toLowerCase() !== "learner" && (
              <>
                <IconButton
                  sx={{
                    color: "#FFFFFF",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #5f5600ff",
                    mx: 1,
                    padding: 0,
                   
                  }}
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <MoveDownIcon
                    sx={{
                      color:"#5f5600ff",
                      borderRadius: "50%",
                      padding: 0.4,
                      "@media (min-width: 1636px)": {
                        fontSize: "2.2rem",
                      },
                    }}
                  />
                </IconButton>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {props.totalAsets &&
                    new Array(props.totalAsets).fill("").map((val, index) => {
                      return (
                        <MenuItem
                          onClick={() => {
                            props.jumpTo(index);
                            setAnchorEl(null);
                          }}
                        >
                          {index + 1}
                        </MenuItem>
                      );
                    })}
                </Menu>
              </>
            )}
          </Grid>
        </Grid>
        <AssetInfo
          visible={infoModl}
          info={props.info}
          toggleModal={(flag) => setInfoModl(flag)}
        ></AssetInfo>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#F5F5F5",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CCC",
      borderRadius: 5,
    },
    overflow: "auto",
  },
});

export default InstructionCard;
